module.exports = __webpack_public_path__ + "img/popup-a.2de99432.png";